import { setHandoffCookie } from '@/utils/handoff'

/**
 * Mixin de handoff de empresa.
 * Registrar APENAS no componente de layout raiz (PrivateBaseLayout).
 * Intercepta intenções de abrir nova aba e seta o cookie preventivamente.
 */
export default {
  mounted () {
    this._handoffAux = this._onAuxClick.bind(this)
    this._handoffClick = this._onCtrlClick.bind(this)
    this._handoffCtx = this._onContextMenu.bind(this)
    document.addEventListener('auxclick', this._handoffAux)
    document.addEventListener('click', this._handoffClick)
    document.addEventListener('contextmenu', this._handoffCtx)
  },
  beforeDestroy () {
    document.removeEventListener('auxclick', this._handoffAux)
    document.removeEventListener('click', this._handoffClick)
    document.removeEventListener('contextmenu', this._handoffCtx)
  },
  methods: {
    _getEmpresaValue () {
      const empresa = this.$store.getters['company/company']
      return empresa ? JSON.stringify(empresa) : null
    },
    _armHandoff (e) {
      const value = this._getEmpresaValue()
      if (!value) return
      const anchor = e.target.closest('a[href]')
      if (!anchor) return
      if (!anchor.href.startsWith(window.location.origin)) return
      setHandoffCookie(value)
    },
    _onAuxClick (e) {
      if (e.button === 1) this._armHandoff(e)
    },
    _onCtrlClick (e) {
      if (e.ctrlKey || e.metaKey || e.shiftKey) this._armHandoff(e)
    },
    _onContextMenu (e) {
      this._armHandoff(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/handoffGuard.js